import { Owner } from 'api'
import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

interface Props {
  onDelete: (owner: Owner) => void
  owner: Owner
}

export default function DeleteShareholderButton({ onDelete, owner }: Props): React.ReactElement {
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false)
  return (
    <>
      <DeleteEntityModal
        isOpen={deleteModalOpen}
        shareholder={owner}
        onDelete={() => {
          onDelete(owner)
          setDeleteModalOpen(false)
        }}
        onCancel={() => setDeleteModalOpen(false)}
      />
      <button
        type="button"
        title="Delete Shareholder"
        aria-label="Delete Shareholder"
        className="btn btn-link text-danger p-0 m-0 pt-1"
        onClick={() => setDeleteModalOpen(true)}
      >
        <i className="mdi mdi-delete" style={{ fontSize: '1.5rem' }} />
      </button>
    </>
  )
}

const DeleteEntityModal = ({
  shareholder,
  onDelete,
  onCancel,
  isOpen,
}: {
  shareholder: Owner
  onDelete: () => void
  onCancel: () => void
  isOpen: boolean
}) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Delete {shareholder.legalBusinessName} and all its shareholders?</ModalHeader>
      <ModalBody>
        <p>This will delete {shareholder.legalBusinessName} and all its shareholders.</p>
      </ModalBody>
      <ModalFooter className="text-right">
        <Button color="primary" onClick={onDelete}>
          Ok
        </Button>
        <Button color="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}
